export default {
    dependencies: ['DetailsPolyfill'],
    callable(DetailsPolyfill) {
        DetailsPolyfill.apply();
    },
};



// WEBPACK FOOTER //
// ./controllers/detailsPolyfillInit.js